module.exports = __webpack_public_path__ + "assets/img/card-bg-armor.a3f8cbf4.png";